import { createContext, useContext } from 'react';

// Implemented in base.jsx
export const DiffitUserContext = createContext({});

export const useDiffitUserContext = () => {
  return useContext(DiffitUserContext);
};
